export const getSpConfig = () => ({
  accountId: Number(process.env.NEXT_PUBLIC_SP_ACCOUNT_ID || 1239),
  baseEndpoint:
    process.env.NEXT_PUBLIC_SP_BASE_ENDPOINT || 'https://sourcepoint.wetter.de',
  propertyHref: process.env.NEXT_PUBLIC_SP_PROPERTY_HREF || 'https://wetter.de',
})
